import React, { useState } from 'react';
import { Button, Toast, ToastContainer } from 'react-bootstrap';

// CopyButton Component
const CopyButton = ({ inputText }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  // Function to handle copying text to clipboard
  const handleCopy = () => {
    if (typeof inputText === 'string' && inputText.trim() !== '') {
      navigator.clipboard
        .writeText(inputText)
        .then(() => {
          setToastMessage('Text Copied!'); // Success message
          setShowToast(true); // Show toast
        })
        .catch((err) => {
          setToastMessage('Failed to copy text.'); // Error message
          setShowToast(true); // Show toast
          console.error('Failed to copy text: ', err);
        });
    } else {
      setToastMessage('No text to copy.'); // Error message if inputText is empty or invalid
      setShowToast(true); // Show toast
    }
  };

  return (
    <>
      {/* Copy Button */}
      <Button className='mt-2' variant="dark" size="sm" onClick={handleCopy}>
        Copy
      </Button>

      {/* Toast Notification */}
      <ToastContainer position="top-end" className="m-3 p-3" style={{ zIndex: 1020 }}>
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default CopyButton;